import { ReactNode } from "react";
import { Box, LinearProgress } from "@material-ui/core";
import useFirestore from "hooks/useFirestore";
import FeatureBlockedNotice from "components/FeatureBlockedNotice";

type VirtualNumberGateProps = {
  children: ReactNode;
};

export default function VirtualNumberGate({ children }: VirtualNumberGateProps) {
  const { userSettings, isLoadingUser } = useFirestore();

  if (isLoadingUser || !userSettings) {
    return (
      <Box my={4} p={2} sx={{ width: "100%" }}>
        <LinearProgress />
      </Box>
    );
  }

  const hasVirtualNumber = (userSettings.virtualNumbers?.length ?? 0) > 0;

  if (!hasVirtualNumber) {
    return <FeatureBlockedNotice />;
  }

  return <>{children}</>;
}
